import PropTypes from 'prop-types';

function MMShopByActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M10.7051 14.5432L9.33383 12.3447L25.4029 14.5712L26.7742 16.7697L10.7051 14.5432Z"
                fill="#AFC272"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.7755 16.7706L10.7067 14.543L8.47284 30.5671L24.5416 32.7947L26.7755 16.7706Z"
                fill="#F1EAD0"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M32.6739 17.5876L26.7729 16.7695L24.5391 32.7937L30.4401 33.6117L32.6739 17.5876Z"
                fill="#AFC272"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M34.1001 21.8001L28.1986 20.9817L26.7742 16.7695L32.6728 17.5878L34.1001 21.8001Z"
                fill="#F1EAD0"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.4016 11.0519C23.5118 9.97942 23.6962 7.58779 23.6962 7.58779"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.7673 12.8871C29.267 12.3828 30.3268 11.2256 30.3268 11.2256"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.971 10.4398C16.725 9.76769 16.1225 8.29102 16.1225 8.29102"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default MMShopByActive;

MMShopByActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMShopByActive.defaultProps = {
    className: null,
};
